var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-wrapper"},[_c('video',{ref:"video",staticClass:"video-wrapper__video",attrs:{"controls":_vm.isMobile,"autoplay":"","muted":"","webkit-playsinline":"","playsinline":""},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }